export default __webpack_public_path__ + "static/IAMProxyIngestRole_TrustRelationship-896c5b87348a3ceaaf5b85649c1e8447.png";